/**
 * The Shop's subscriptions (Premium Lite | Premium). «Passa a Premium» on the
 * web lands here rather than on the Shop home (client, 23/10/2026); a Premium
 * Lite member finds Premium already selected.
 */
export const SUBSCRIPTIONS_SHOP_PATH = "/shopping-widget/section/masterclub";
